"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  ArrangeLetter: ['arrange-letter', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.75,15.248H7A.25.25,0,0,1,6.75,15V3.748a1,1,0,0,0-2,0V15a.25.25,0,0,1-.25.25H2.75A.5.5,0,0,0,2.4,16.1l3,3a.5.5,0,0,0,.707,0l3-3a.5.5,0,0,0-.353-.854Z', 'M21.562,14.523a1.5,1.5,0,0,0-1.312-.775h-3.6a1,1,0,0,0,0,2H18.9a.25.25,0,0,1,.212.383l-3.327,5.323a1.5,1.5,0,0,0,1.274,2.294h3.6a1,1,0,0,0,0-2H18.407a.25.25,0,0,1-.212-.382l3.324-5.32A1.5,1.5,0,0,0,21.562,14.523Z', 'M18.75.248a3,3,0,0,0-3,3v6a1,1,0,0,0,2,0V6.5a.25.25,0,0,1,.25-.25h1.5a.25.25,0,0,1,.25.25v2.75a1,1,0,0,0,2,0v-6A3,3,0,0,0,18.75.248Zm-.75,4A.25.25,0,0,1,17.75,4v-.75a1,1,0,0,1,2,0V4a.25.25,0,0,1-.25.25Z']],
  ArrangeNumber: ['arrange-number', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.5,15.248H6.75A.25.25,0,0,1,6.5,15V3.748a1,1,0,0,0-2,0V15a.25.25,0,0,1-.25.25H2.5a.5.5,0,0,0-.354.853l3,3a.5.5,0,0,0,.707,0l3-3a.5.5,0,0,0-.353-.853Z', 'M21,8.248H19.75A.25.25,0,0,1,19.5,8V1.748A1.5,1.5,0,0,0,17.062.577l-1.687,1.35a1,1,0,0,0,1.25,1.561l.469-.375a.25.25,0,0,1,.406.195V8a.25.25,0,0,1-.25.25H16a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2Z', 'M18,13.748a3.5,3.5,0,1,0,.747,6.919.25.25,0,0,1,.24.411,1.985,1.985,0,0,1-1.487.67H17a1,1,0,0,0,0,2h.5a4,4,0,0,0,4-4v-2.5A3.5,3.5,0,0,0,18,13.748Zm0,5a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,18,18.748Z']],
  Translate: ['translate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.917,11H15.5a.5.5,0,0,0-.5.5v.417A3.083,3.083,0,0,1,11.917,15H11.5a.5.5,0,0,0-.5.5v7.417A1.083,1.083,0,0,0,12.083,24H22.917A1.083,1.083,0,0,0,24,22.915V12.081A1.083,1.083,0,0,0,22.917,11ZM20.764,22.2a.741.741,0,0,1-.264.048.749.749,0,0,1-.7-.486l-.507-1.352a.251.251,0,0,0-.234-.162H15.943a.251.251,0,0,0-.234.162L15.2,21.762a.75.75,0,0,1-1.4-.528l2.532-6.751a1.25,1.25,0,0,1,2.34,0l1.758,4.687a.889.889,0,0,1,.038.1l.736,1.963A.75.75,0,0,1,20.764,22.2Z', 'M16.459,18.41a.25.25,0,0,0,.234.338h1.614a.25.25,0,0,0,.234-.338l-.807-2.151a.25.25,0,0,0-.468,0Z', 'M7.779,5.607a.251.251,0,0,0-.226-.359H5.447a.251.251,0,0,0-.226.359A7.962,7.962,0,0,0,6.309,7.274a.249.249,0,0,0,.382,0A7.962,7.962,0,0,0,7.779,5.607Z', 'M11.917,13A1.083,1.083,0,0,0,13,11.915V1.081A1.083,1.083,0,0,0,11.917,0H1.083A1.083,1.083,0,0,0,0,1.081V11.915A1.083,1.083,0,0,0,1.083,13Zm-1.193-2.3a.751.751,0,0,1-.724.554.782.782,0,0,1-.2-.026A9.212,9.212,0,0,1,6.651,9.67a.249.249,0,0,0-.3,0A9.212,9.212,0,0,1,3.2,11.222a.782.782,0,0,1-.2.026.749.749,0,0,1-.2-1.473,7.707,7.707,0,0,0,2.365-1.1A.253.253,0,0,0,5.275,8.5.248.248,0,0,0,5.217,8.3,9.508,9.508,0,0,1,3.53,5.412.249.249,0,0,0,3.3,5.248H2.531a.75.75,0,0,1,0-1.5H5.5a.25.25,0,0,0,.25-.25v-1a.75.75,0,1,1,1.5,0v1a.25.25,0,0,0,.25.25h3a.75.75,0,0,1,0,1.5H9.705a.249.249,0,0,0-.235.164A9.508,9.508,0,0,1,7.783,8.3a.25.25,0,0,0,.048.368,7.707,7.707,0,0,0,2.365,1.1A.749.749,0,0,1,10.724,10.694Z', 'M17.646,5.352A.5.5,0,0,0,18.5,5v-.31a.25.25,0,0,1,.367-.221A4,4,0,0,1,21,8a1,1,0,1,0,2,0,6,6,0,0,0-4.32-5.753.25.25,0,0,1-.18-.24V1a.5.5,0,0,0-.309-.462.506.506,0,0,0-.545.109l-2,2a.5.5,0,0,0,0,.707Z', 'M2,14a1,1,0,0,0-1,.992L1,15a6,6,0,0,0,4.32,5.753.25.25,0,0,1,.18.24V22a.5.5,0,0,0,.854.354l2-2a.5.5,0,0,0,0-.707l-2-2A.5.5,0,0,0,5.5,18v.31a.252.252,0,0,1-.121.215.248.248,0,0,1-.246.006A4,4,0,0,1,3,15,1,1,0,0,0,2,14Z']],
  Redo: ['redo', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.608.161a.5.5,0,0,0-.545.108L19.472,2.86a.25.25,0,0,1-.292.045A12.537,12.537,0,0,0,6.214,3.77,12.259,12.259,0,0,0,6.1,23.632a1.25,1.25,0,0,0,1.476-2.018A9.759,9.759,0,0,1,7.667,5.805a10,10,0,0,1,9.466-1.1.25.25,0,0,1,.084.409l-1.85,1.85a.5.5,0,0,0,.354.853h6.7a.5.5,0,0,0,.5-.5V.623A.5.5,0,0,0,22.608.161Z']],
  SpellingCheck: ['spelling-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.161,12.293a.252.252,0,0,1,.235.164l1.166,3.18a1,1,0,1,0,1.877-.688L8.409,1.23a1.5,1.5,0,0,0-2.817,0L.562,14.949a1,1,0,1,0,1.877.688l1.166-3.18a.25.25,0,0,1,.234-.164Zm-3.4-8.456a.251.251,0,0,1,.47,0l2.244,6.12a.25.25,0,0,1-.235.336H4.756a.25.25,0,0,1-.235-.336Z', 'M23.081,8.48a1,1,0,0,0-1.394.232L12.715,21.271a.5.5,0,0,1-.76.063L8.207,17.586A1,1,0,1,0,6.793,19l4.165,4.165a2,2,0,0,0,1.411.586c.055,0,.111,0,.166-.007A1.988,1.988,0,0,0,14,22.913L23.314,9.874A1,1,0,0,0,23.081,8.48Z']],
  SearchText: ['search-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23.457,23.211a1,1,0,0,0,0-1.414l-4.664-4.665a.5.5,0,0,1-.045-.655A10.291,10.291,0,1,0,9.79,20.531a.25.25,0,0,1,.232.249v.962a.249.249,0,0,1-.25.25H8.579a1,1,0,0,0,0,2h4.887a1,1,0,0,0,0-2H12.272a.25.25,0,0,1-.25-.25V20.667a.251.251,0,0,1,.209-.247A10.17,10.17,0,0,0,16.724,18.5a.5.5,0,0,1,.655.045l4.664,4.665a1,1,0,0,0,1.414,0ZM2.25,10.288A8.284,8.284,0,1,1,16.4,16.137l-.009.007-.007.009A8.284,8.284,0,0,1,2.25,10.288Z', 'M11.022,16.663a1,1,0,0,0,1-1V10.306a.5.5,0,0,1,.5-.5L14.9,9.8a.5.5,0,0,1,.5.5v1.454a1,1,0,0,0,2,0V9.8a1.979,1.979,0,0,0-1.976-1.978h-8.8A1.98,1.98,0,0,0,4.647,9.8v1.955a1,1,0,0,0,2,0l-.016-1.428a.5.5,0,0,1,.5-.506l2.391-.006a.5.5,0,0,1,.5.5v5.349A1,1,0,0,0,11.022,16.663Z']],
  TaskText: ['task-text', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M13.709,4.727a.251.251,0,0,0,.2.265A1.089,1.089,0,0,1,14.734,6.1V9.333a1.244,1.244,0,0,0,1.244,1.244h0a1.244,1.244,0,0,0,1.244-1.244V3.975a1.494,1.494,0,0,0-1.495-1.494H14a.246.246,0,0,0-.177.074.249.249,0,0,0-.073.177C13.751,3.205,13.75,4.224,13.709,4.727Z', 'M9.264,21.262A1.244,1.244,0,0,0,8.02,20.018H3.794a1.073,1.073,0,0,1-1-1.136V6.1a1.086,1.086,0,0,1,.842-1.115.25.25,0,0,0,.2-.258c-.039-.766-.051-1.6-.055-2a.249.249,0,0,0-.25-.247H1.805A1.494,1.494,0,0,0,.31,3.975V21.012A1.493,1.493,0,0,0,1.8,22.505H8.02a1.244,1.244,0,0,0,1.244-1.243Z', 'M12.247,4.472V2.484a.5.5,0,0,0-.5-.5h-.758a.252.252,0,0,1-.249-.222,1.989,1.989,0,0,0-3.953,0,.249.249,0,0,1-.249.222H5.783a.5.5,0,0,0-.5.5V4.472a.5.5,0,0,0,.5.5H11.75A.5.5,0,0,0,12.247,4.472Z', 'M21.7,12.646a1.994,1.994,0,0,0-1.41-.584H12.745a1.994,1.994,0,0,0-1.995,1.993V23a1,1,0,0,0,2,0l-.005-7.939a1,1,0,0,1,1-1l6.127,0a1,1,0,0,1,.707.292l.818.816a1,1,0,0,1,.293.708V23a1,1,0,0,0,2,0V15.46a1.993,1.993,0,0,0-.584-1.409Z', 'M19.209,19.269H15.231a.75.75,0,1,0,0,1.5h3.978a.75.75,0,1,0,0-1.5Z', 'M15.231,17.289h2.486a.75.75,0,1,0,0-1.5H15.231a.75.75,0,1,0,0,1.5Z']],
  Undo: ['undo', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.786,3.77A12.542,12.542,0,0,0,4.821,2.905a.249.249,0,0,1-.292-.045L1.937.269A.507.507,0,0,0,1.392.16a.5.5,0,0,0-.308.462v6.7a.5.5,0,0,0,.5.5h6.7a.5.5,0,0,0,.354-.854L6.783,5.115a.253.253,0,0,1-.068-.228.249.249,0,0,1,.152-.181,10,10,0,0,1,9.466,1.1,9.759,9.759,0,0,1,.094,15.809A1.25,1.25,0,0,0,17.9,23.631a12.122,12.122,0,0,0,5.013-9.961A12.125,12.125,0,0,0,17.786,3.77Z']],
  PrinterView: ['printer-view', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M6.5,5a1,1,0,0,0,1-1V2.5A.5.5,0,0,1,8,2h7.376a.5.5,0,0,1,.353.147l.621.621a.5.5,0,0,1,.146.353V4a1,1,0,0,0,2,0V2.5a1,1,0,0,0-.292-.707L16.7.292A1,1,0,0,0,15.993,0H7A1.5,1.5,0,0,0,5.5,1.5V4A1,1,0,0,0,6.5,5Z', 'M12.187,20.991H8.5a1,1,0,0,1-1-1v-4a1,1,0,0,1,1-1h4.692a.25.25,0,0,0,.2-.105,6.238,6.238,0,0,1,10.222.036.249.249,0,0,0,.271.1.141.141,0,0,0,.1-.137V9a2.5,2.5,0,0,0-2.5-2.5H2.5A2.5,2.5,0,0,0,0,9v6a2.5,2.5,0,0,0,2.5,2.5H5.248a.25.25,0,0,1,.25.25v3.749c0,.855.826,1.5,1.922,1.5h4.827a.951.951,0,0,0,.8-1.447l-.016-.029A.973.973,0,0,0,12.187,20.991ZM4.5,9.495a1,1,0,1,1-1-1A1,1,0,0,1,4.5,9.495Z', 'M22.429,21.015a.25.25,0,0,1-.04-.3,4.438,4.438,0,0,0,.6-2.222,4.5,4.5,0,1,0-4.5,4.5,4.442,4.442,0,0,0,2.222-.6.251.251,0,0,1,.3.039l1.278,1.278a1,1,0,0,0,1.413-1.413Zm-6.436-2.523a2.5,2.5,0,1,1,2.5,2.5A2.5,2.5,0,0,1,15.993,18.492Z']]
};
exports["default"] = _default;